export const getUserData = () => {
  const rawAtributos = sessionStorage.getItem("atributos");
  let parsedAtributos = {};

  try {
    parsedAtributos = JSON.parse(rawAtributos || "{}");
  } catch (error) {
    console.error("Error al parsear los atributos del usuario:", error);
  }

  return {
    // Datos básicos
    apellido: sessionStorage.getItem("apellido") || "",
    nombre: sessionStorage.getItem("nombre") || "",
    usuario: sessionStorage.getItem("usuario") || "",
    userId: parseInt(sessionStorage.getItem("userId")) || null,

    // Roles (array)
    roles: JSON.parse(sessionStorage.getItem("roles") || "[]"),

    // Aplicaciones disponibles
    apps: JSON.parse(sessionStorage.getItem("apps") || "[]"),

    // Atributos por app
    atributos: parsedAtributos,

    // Permisos por app (si están disponibles)
    permisosPorApp: {
      DOCUMENTOS: getPermisosApp(parsedAtributos, "DOCUMENTOS"),
      BODEGA: getPermisosApp(parsedAtributos, "BODEGA"),
      MEDIDORES: getPermisosApp(parsedAtributos, "MEDIDORES"),
    },

    // Perfil por app (si están disponibles)
    perfilPorApp: {
      DOCUMENTOS: getPerfilApp(parsedAtributos, "DOCUMENTOS"),
      BODEGA: getPerfilApp(parsedAtributos, "BODEGA"),
      MEDIDORES: getPerfilApp(parsedAtributos, "MEDIDORES"),
    },
  };
};

// Helpers internos
const getPermisosApp = (atributos, appName) => {
  try {
    const permisosStr = atributos?.["1"]?.[appName]?.permisos;
    return permisosStr ? JSON.parse(permisosStr) : [];
  } catch {
    return [];
  }
};

const getPerfilApp = (atributos, appName) => {
  return atributos?.["1"]?.[appName]?.perfil || "";
};
